import { render, staticRenderFns } from "./ProvinceMapChart.vue?vue&type=template&id=5095bf75&scoped=true"
import script from "./ProvinceMapChart.vue?vue&type=script&lang=js"
export * from "./ProvinceMapChart.vue?vue&type=script&lang=js"
import style0 from "./ProvinceMapChart.vue?vue&type=style&index=0&id=5095bf75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095bf75",
  null
  
)

export default component.exports